import React from "react";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
// Components //
import TitleSection from "../../molecules/title-section";
// Styles //
import "./company-connection.scss";

const CompanyConnection = (props: ReferenciaContenido) => {
    const { tituloGeneral, redireccionBoton, descripcion } = props;
    return (
        <div className={`o-company-connection ${props.contentful_id === "7cLQBznQHrv0qnBHWfe4pO" ? "containerMpc" : ""}`}>
            <div className={`container`}>
                <TitleSection title={tituloGeneral} />
                <div className="company-connection-item">
                    <div className="company-connection-item__video">
                        <iframe
                            className="video"
                            src={redireccionBoton}
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        ></iframe>
                    </div>
                    <div className="company-connection-item__text">
                        {descripcion.json &&
                            documentToReactComponents(descripcion.json)}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CompanyConnection;
